const verdicts = {
    'AC' : {
        color: 'verdict-success',
        alias: 'AC'
    },
    'WA' : {
        color: 'verdict-danger',
        alias: 'WA'
    },
    'OK' : {
        color: 'verdict-warning',
        alias: 'OK'
    },
    'RTE' : {
        color: 'verdict-warning',
        alias: 'RTE'
    },
    'TLE' : {
        color: 'verdict-warning',
        alias: 'TLE'
    },
    'CE' : {
        color: 'verdict-warning',
        alias: 'CE'
    },
    '!!!' : {
        color: 'verdict-none',
        alias: 'ERR'
    },
    '?' : {
        color: 'verdict-none',
        alias: 'PEND'
    }
};

export default verdicts;